<template>
    <div class="form_box_components">
        <a-form ref="searchRef" :model="form" class="form " scrollToFirstError
            :class="{ form_flex : form_data.length > 7 && flex || is_flex}" :layout="layout" :labelCol="labelCol"
            :wrapperCol="wrapperCol">
            <template v-for="(item, index) in form_data" :key="index">
                <a-form-item class="form_item_box" :label="item.label" :colon="'colon' in item ? item.colon : true"
                    :rules="item.rules ? item.rules : []" :name="item.name" v-if="item.type == 'input'">
                    <a-input allowClear v-model:value="form[item.name]"
                        @change="item.onChange ? item.onChange($event) : null"
                        :style="{ width: item.width ? item.width : '' }" :disabled="item.disabled"
                        :placeholder="item.placeholder ?? '请输入'" :show-count="item.maxNumber ? true : false"
                        :maxlength="item.maxNumber ? item.maxNumber : null">
                    </a-input>
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    :name="item.name" v-else-if="item.type == 'password'" :colon="'colon' in item ? item.colon : true">
                    <template #label>
                        <span>{{item.label}}</span>
                    </template>
                    <a-input-password v-model:value="form[item.name]" :style="{ width: item.width ? item.width : '' }"
                        :disabled="item.disabled" :placeholder="item.placeholder ?? '请输入'" />
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'select'" :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-select allowClear show-search :filterOption="filterOption" ref="select" :disabled="item.disabled"
                        v-model:value="form[item.name]" :style="{ width: item.width ? item.width : '' }"
                        :placeholder="item.placeholder ?? '请选择'" :options="item.list"
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        @change="item.onChange ? item.onChange($event) : null"></a-select>
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'multiple'" :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-select mode="multiple" allowClear show-search :filterOption="filterOption" ref="select"
                        v-model:value="form[item.name]" :disabled="item.disabled"
                        :maxTagCount="item.maxTagCount ? item.maxTagCount : 3"
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        :style="{ width: item.width ? item.width : '' }" :placeholder="item.placeholder ?? '请选择'"
                        :options="item.list"></a-select>
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'cascader'" :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-cascader v-model:value="form[item.name]" :style="{ width: item.width ? item.width : '' }"
                        :show-search="{ filter }" :placeholder="item.placeholder ?? '请选择'" :options="item.list"
                        :fieldNames="item.fieldNames ? item.fieldNames : {}" :disabled="item.disabled" />
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'treeMode'" :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-tree-select :treeNodeFilterProp="item.fieldNames?.label" show-search
                        :placeholder="item.placeholder ?? '请选择'" v-model:value="form[item.name]" tree-checkable
                        tree-default-expand-all :tree-data="item.list" :show-checked-strategy="SHOW_PARENT"
                        :fieldNames="{ value: 'id', label: 'name', children: 'children' }"
                        :dropdown-style="{ maxHeight: '', overflow: 'auto' }"
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        :style="{ width: item.width ? item.width : '' }" :disabled="item.disabled">
                    </a-tree-select>
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'tree'" :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-tree-select allow-clear :treeNodeFilterProp="item.fieldNames?.label" show-search
                        :getPopupContainer="item.getPopupContainer ? item.getPopupContainer : (triggerNode) => triggerNode.parentNode"
                        v-model:value="form[item.name]" :style="{ width: item.width ? item.width : '' }"
                        :disabled="item.disabled" :dropdown-style="{ maxHeight: '', overflow: 'auto' }"
                        :tree-data="item.list" :placeholder="item.placeholder ?? '请选择'"
                        :fieldNames="item.fieldNames ? item.fieldNames : {}" />
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'treeCity'" :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-tree-select allow-clear :treeNodeFilterProp="item.fieldNames?.label" show-search
                        v-model:value="form[item.name]" :disabled="item.disabled"
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        :style="{ width: item.width ? item.width : '' }" @change="cityChange($event, item.list, item)"
                        :dropdown-style="{ maxHeight: '', overflow: 'auto' }" :tree-data="item.list"
                        :placeholder="item.placeholder ?? '请选择'" :fieldNames="item.fieldNames ? item.fieldNames : {}" />
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'time'" :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-range-picker allowClear v-model:value="form[item.name]" :disabled="item.disabled"
                        :style="{ width: item.width ? item.width : '' }" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" />
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'date'" :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-date-picker allowClear v-model:value="form[item.name]" :disabled="item.disabled"
                        :showTime="item.showTime" :style="{ width: item.width ? item.width : '' }"
                        :valueFormat="item.showTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'"
                        :format="item.showTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'" />
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'timer'" :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-time-picker allowClear v-model:value="form[item.name]" :disabled="item.disabled"
                        value-format="HH:mm" format="HH:mm" :style="{ width: item.width ? item.width : '' }" />
                </a-form-item>

                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'number'" :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-input-number :placeholder="item.placeholder ?? '请输入'" :disabled="item.disabled"
                        :formatter="numberChange" :parser="numberChange" allowClear v-model:value="form[item.name]"
                        :min="item.min || item.min == 0 ? item.min : null" :precision="item.precision || item.precision == 0 ? item.precision : null"
                        :style="{ width: item.width ? item.width : '' }"
                        @change="item.onChange ? item.onChange($event) : null"
                        :addon-after="item.after ? item.after : null" />
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'decimal'" :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <div>
                        <a-input-number v-model:value="form[item.name]" :min="item.min ? item.min : 0"
                            :max="item.max ? item.max : null" :style="{ width: item.width ? item.width : '' }"
                            :disabled="item.disabled" :parser="value => parseNumber(value, item.precision)"
                            @change="item.onChange ? item.onChange($event) : null" :placeholder="item.placeholder ?? '请输入'"
                            :addon-after="item.after ? item.after : null">
                        </a-input-number>
                    </div>
                    <a-form-item-rest v-if="item.tips">
                        {{item.tips}}
                    </a-form-item-rest>
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'radio'" :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-radio-group v-model:value="form[item.name]" :disabled="item.disabled"
                        :style="{ width: item.width ? item.width : '' }"
                        @change="item.onChange ? item.onChange($event) : null">
                        <a-radio :value="data.value" v-for="(data, daIndex) in item.list" :disabled="data.disabled"
                            :key="daIndex">{{ data.label }}
                        </a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'radioButton'" :name="item.name"
                    :colon="'colon' in item ? item.colon : true">
                    <a-radio-group class="radioButtonBox" :class="{radioButtonBox_2: item.is_url}"
                        v-model:value="form[item.name]" :disabled="item.disabled"
                        :button-style="'solid' in item ? item.solid : 'solid'"
                        :style="{ width: item.width ? item.width : '' }"
                        @change="item.onChange ? item.onChange($event) : null"
                        :size="'size' in item ? item.size : 'default'">
                        <a-radio-button :value="data.value" v-for="(data, daIndex) in item.list"
                            :disabled="data.disabled" :key="daIndex">
                            <template v-if="data.url &&data.urlActive">
                                <img v-if="form[item.name] != data.value" :src="data.url" alt="">
                                <img v-else :src="data.urlActive" alt="">
                            </template>
                            {{ data.label }}
                        </a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'textarea'" :name="item.name"
                    :colon="item.colon || item.colon == false ? item.colon : true">
                    <a-textarea v-model:value="form[item.name]" :style="{ width: item.width ? item.width : '' }"
                        :disabled="item.disabled" :placeholder="item.placeholder ?? '请输入'" :rows="4"
                        :show-count="item.maxNumber ? true : false"
                        :maxlength="item.maxNumber ? item.maxNumber : null" />
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? richtextRules : []"
                    v-else-if="item.type == 'richtext'" :colon="item.colon"
                    :labelCol="item.labelCol ? item.labelCol:labelCol"
                    :wrapperCol="item.wrapperCol ? item.wrapperCol:wrapperCol" :name="item.name" :ref="item.name+'ref'">
                    <Editor :style="{ width: item.width ? item.width : '100%' }" :disable="item.disabled"
                        :data="form[item.name]" @valueHtmlChange="valueHtmlChange($event,item)" />
                    <!-- <Ckeditor :style="{ width: item.width ? item.width : '100%' }" :disable="item.disabled"
                        :data="form[item.name]" @valueHtmlChange="valueHtmlChange($event,item)"></Ckeditor> -->
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" :rules="item.rules ? item.rules : []"
                    v-else-if="item.type == 'checked'" :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-checkbox-group v-model:value="form[item.name]" :style="{ width: item.width ? item.width : '' }"
                        @change="item.onChange ? item.onChange($event) : null">
                        <a-checkbox :value="data.value" v-for="(data, daIndex) in item.list" :key="daIndex"
                            :disabled="data.disabled">
                            {{ data.label }}
                        </a-checkbox>
                    </a-checkbox-group>
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" v-else-if="item.type == 'text'"
                    :colon="'colon' in item ? item.colon : true">
                    {{ form[item.name] }}
                </a-form-item>
                <template v-else-if="item.type == 'slot'">
                    <div class="ant-form-item_ss ant-form-item form_item_box">
                        <slot :name="item.name" :record="item"></slot>
                    </div>
                </template>
                <template v-else-if="item.type == 'none'">
                    <div></div>
                </template>
            </template>
            <a-form-item class="item_btn" v-if="is_button" :wrapperCol="{
      span: wrapperCol.span,
      offset: labelCol.span
    }">
                <a-button @click="resetting">取消</a-button>
                <a-button type="primary" @click="searh">{{successText}}</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
    import {
        TreeSelect
    } from 'ant-design-vue';
    import Editor from '@/components/Editor'
    export default {
        components: {
            Editor,
        },
        props: {
            form_data: {
                type: Object,
                default: []
            },
            // 是否显示底部按钮
            is_button: {
                type: Boolean,
                default: true
            },
            labelCol: {
                type: Object,
                default: {
                    span: 9
                }
            },
            wrapperCol: {
                type: Object,
                default: {
                    span: 15
                }
            },
            form: {
                type: Object,
                default: {}
            },
            calcel: {
                type: Boolean,
                default: false
            },
            successText: {
                type: String,
                default: '保存'
            },
            flex: {
                type: Boolean,
                default: true
            },
            is_flex: {
                type: Boolean,
                default: false
            },
            layout: {
                type: String,
                default: 'horizontal'
            }
        },
        data() {
            return {
                SHOW_PARENT: TreeSelect.SHOW_ALL,
                richtextRules: [{
                    required: true,
                    validator: this.textAsvisss,
                    trigger: 'change',
                }]
            }
        },
        watch: {
            form_data: {
                handler(val, oldVal) {
                    val.forEach(item => {
                        if (item.default || item.default == 0) {
                            this.form[item.name] = item.default
                        }
                    })
                    this.$nextTick(() => {
                        this.$refs.searchRef ?.clearValidate()
                    })
                },
                deep: true,
                immediate: true
            }
        },
        created() {

        },
        methods: {
            parseNumber(value, precision) {
                return this.$methods.parseNumber(value, precision)
            },
            searh() {
                this.$refs.searchRef.validateFields().then(() => {
                    this.$emit('save')
                })
            },
            //取消
            resetting() {
                if (this.calcel) {
                    console.log('取消');
                    this.$emit('backTo')

                } else {
                    this.$router.back()
                }

            },
            //对选择框筛选
            filterOption(input, option) {
                return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // 级联选择框搜索
            filter(inputValue, path) {
                return path.some(option => option.label ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >
                    -1 : option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
            },
            //处理数字只能为整数
            numberChange(val) {
                if (typeof val === 'string') {
                    return !isNaN(Number(val)) ? val.replace(/\./g, '') : 0
                } else if (typeof val === 'number') {
                    return !isNaN(val) ? String(val).replace(/\./g, '') : 0
                } else {
                    return 0
                }
            },
            // 城市树选择
            cityChange(val, data, item) {
                let key = item.key ? item.key : 'id'
                let arr = this.$methods.getMenuArrayParent(data, val)
                this.form.province = arr[0] ? arr[0][key] : ''
                this.form.city = arr[1] ? arr[1][key] : ''
                this.form.area = arr[2] ? arr[2][key] : ''
            },
            // 表单校验
            validateFields() {
                return new Promise((reslove, reject) => {
                    this.$refs.searchRef.validateFields().then(() => {
                        reslove()
                    }).catch((err) => {
                        this.validate()
                        reject()
                    })
                })
            },
            // 校验失败滚动表单
            validate() {
                this.$nextTick(() => {
                    const errorDiv = document.getElementsByClassName('ant-form-item-has-error')
                    errorDiv[0] ?.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    })
                })
            },
            //表单重置
            resetFields(arr = []) {
                this.$refs.searchRef.resetFields(arr.length ? arr : null)
            },
            //自定义富文本校验规则
            textAsvisss(_rule, value) {
                if (!value || !this.$methods.getWangEditorText(value)) {
                    return Promise.reject('请输入内容');
                } else {
                    return Promise.resolve();
                }
            },
            // 富文本校验
            valueHtmlChange(data, item) {
                this.form[item.name] = data.value
                this.$nextTick(() => {
                    if (Array.isArray(this.$refs[item.name + 'ref'])) {
                        this.$refs[item.name + 'ref'][0].onFieldChange()
                    } else {
                        this.$refs[item.name + 'ref'].onFieldChange()
                    }
                })
            },
        }
    }
</script>

<style lang="less" scoped>
    .form_box_components {
        .form {

            .ant-btn {
                margin-right: 10px;
            }

            .ant-form-item {
                .ant-form-item-control-input-content>* {
                    width: 400px;
                }

            }


            .item_btn {
                margin-left: 0;

                .ant-form-item-control-input-content>* {
                    width: fit-content;
                }
            }

        }

        .form_flex {
            display: flex;
            flex-flow: wrap;
            align-items: center;

            .ant-form-item {
                width: 50%;

                .ant-form-item-control-input-content>* {
                    width: 300px;
                }
            }

            .ant-form-item_ss {
                margin-bottom: 0 !important;
            }
        }
    }

    // .ant-input-textarea-show-count::after {
    //     position: absolute;
    //     bottom: 0;
    //     right: 432px;
    //     margin-bottom: 0;
    // }
</style>